// extracted by mini-css-extract-plugin
export default {"base":"vp_O_qVY","site-story-toast-in":"vp_KwMgj","icon":"vp_dYTZE","message":"vp_Yoihj"};